namespace TabAurous.OMS {
    export namespace SalesPersonWiseSalesService {
        export const baseUrl = 'OMS/SalesPersonWiseSales';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<TargetMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "OMS/SalesPersonWiseSales/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>SalesPersonWiseSalesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
